import { spec, validators } from 'utils/validation'

const { any, custom } = validators

export const formModel = ({ tmConfig }) => ({
  customDate: {
    initialValue: tmConfig?.customDate
      ? new Date(tmConfig.customDate)
      : new Date(),
    spec: spec.flow(any.required),
  },

  effectiveDate: {
    initialValue: tmConfig?.effectiveDateStr,
    spec: spec.flow(custom.valid),
  },

  serverDateWhenCustomDateSet: {
    initialValue: tmConfig?.serverDateWhenCustomDateSetStr,
    spec: spec.flow(custom.valid),
  },

  schedulerEnabled: {
    initialValue: tmConfig?.schedulerEnabled,
    spec: spec.flow(any.required),
  },
})
